import React from 'react';
import {
    Image,
    TouchableOpacity,
    StyleSheet
} from 'react-native';

import Colors from '../../constants/Colors';

const RatingStarComponent = ({ starId, starPressed, onPress }) => {

    let colorToUse = starId <= starPressed ? Colors.starFull : Colors.starEmpty;

    const disabled = onPress === undefined ? true : false;

    return (
        <TouchableOpacity
            style={styles.containerStyle}
            onPress={() => {
                if (onPress) onPress(starId)
            }}
            disabled={disabled}

        >
            <Image
                source={require('../../img/icons/RatingIcon.png')}
                style={[styles.imageStyle, {tintColor: colorToUse}]}
                resizeMode={'contain'}
            />
        </TouchableOpacity>
    )
};

const styles = StyleSheet.create({
    containerStyle: {
        height: 40,
        width: 40,
        justifyContent: 'center',
        alignItems: 'center',
    },
    imageStyle: {
        height: 40,
        width: 40,
    }
});

export default RatingStarComponent;
